import axios from "../axiosInstance";

export async function contactUs(formData) {
  console.log(formData, "line 4 api screen");
  let response = await axios
    .post("save_quick_connects", formData)
    .then((response) => {
      if (response.message === "Data was Inserted") {
        return "Our Team Shall Connect To You Soon!!";
      }
      return "success";
    })
    .catch((err) => {
      return err;
    });
  return response;
}

export async function enquire(formData) {
  console.log(formData, "line 4 api screen");
  let response = await axios
    .post("save_enquiry", formData)
    .then((response) => {
      if (response.message === "Data was Inserted") {
        return "Our Team Shall Connect To You Soon!!";
      }
      return "success";
    })
    .catch((err) => {
      return err;
    });
  return response;
}

export async function interested(formData) {
  console.log(formData, "line 36 api screen");
  let response = await axios
    .post("save_interested_users", formData)
    .then((response) => {
      // console.log(response.data);
      if (response.message === "Data was Inserted") {
        return "Our Team Shall Connect To You Soon!!";
      }
      // console.log(response.message);
      return "success";
    })
    .catch((err) => {
      return err;
    });
  return response;
}

export async function eventRegistration(formData) {
  console.log(formData, "line 36 api screen");
  let response = await axios
    .post("save_events_registration", formData)
    .then((response) => {
      // console.log(response.data);
      if (response.message === "Data was Inserted") {
        return "Our Team Shall Connect To You Soon!!";
      }
      // console.log(response.message);
      return "success";
    })
    .catch((err) => {
      return err;
    });
  return response;
}
